/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { createContext, useEffect, useState } from 'react';

const RecipientBookContext = createContext(null);

const RecipientBookContextProvider = ({ children }) => {
    const [recipientState, setRecipientState] = useState({});
    const [currentRecipient, setCurrentRecipient] = useState({});
    const [filteredRecipients, setFilteredRecipients] = useState({});
    const [isOccasionsEditing, setIsOccasionsEditing] = useState(false);
    const [selectedOccasionToEdit, setSelectedOccasionToEdit] = useState('');
    const [selectedAddressToEdit, setSelectedAddressToEdit] = useState({});
    const [isAddressEditing, setIsAddressEditing] = useState(false);
    const [isProfileEditing, setIsProfileEditing] = useState(false);
    const [addNewAddressClicked, setAddNewAddressClicked] = useState(false);
    const [closeBtnClicked, setCloseBtnClicked] = useState(false);
    const [showMoreOccasions, setShowMoreOccasions] = useState(false);
    const [recipientsCopy, setRecipientsCopy] = useState({ addressBookResponse: { addressList: [] } });
    const [isReturnToRecipientListOnMobileClicked, setIsReturnToRecipientListOnMobileClicked] = useState(false);
    const [isEditingRecipient, setIsEditingRecipient] = useState(false);

    // Below are QAS states
    const [isVerificationNeeded, setIsVerificationNeeded] = useState(false);
    const [confirmAddress, setConfirmAddress] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [formatedSelectedAddress, setFormatedSelectedAddress] = useState({});
    const [keepAddressClicked, setKeepAddressClicked] = useState(false);
    const [chooseAddressClicked, setChooseAddressClicked] = useState(false);
    const [isLoadingConfirmation, setIsLoadingConfirmation] = useState(false);
    const [showSuggestedAddressDropdown, setShowSuggestedAddressDropdown] = useState(false);

    useEffect(() => {
        // Make a copy of the recipient state each time the user adds or deletes a recipient
        if (!recipientsCopy?.addressBookResponse?.addressList?.length) {
            setRecipientsCopy({...recipientState})
        }
    }, [recipientState])

    const data = {
        recipientState,
        setRecipientState,
        currentRecipient,
        setCurrentRecipient,
        filteredRecipients,
        setFilteredRecipients,
        isOccasionsEditing,
        setIsOccasionsEditing,
        selectedAddressToEdit,
        setSelectedAddressToEdit,
        isAddressEditing,
        setIsAddressEditing,
        isProfileEditing,
        setIsProfileEditing,
        selectedOccasionToEdit,
        setSelectedOccasionToEdit,
        addNewAddressClicked, 
        setAddNewAddressClicked,
        isVerificationNeeded,
        setIsVerificationNeeded,
        confirmAddress,
        setConfirmAddress,
        searchResults,
        setSearchResults,
        formatedSelectedAddress,
        setFormatedSelectedAddress,
        keepAddressClicked,
        setKeepAddressClicked,
        chooseAddressClicked,
        setChooseAddressClicked,
        isLoadingConfirmation,
        setIsLoadingConfirmation,
        showMoreOccasions,
        setShowMoreOccasions,
        closeBtnClicked, 
        setCloseBtnClicked,
        isReturnToRecipientListOnMobileClicked,
        setIsReturnToRecipientListOnMobileClicked,
        recipientsCopy,
        setRecipientsCopy,
        isEditingRecipient,
        setIsEditingRecipient,
        setShowSuggestedAddressDropdown,
        showSuggestedAddressDropdown,
    };

    return (
        <RecipientBookContext.Provider value={data}>
            {children}
        </RecipientBookContext.Provider>
    );
};

export { RecipientBookContextProvider, RecipientBookContext };
